import { LOCALES } from 'i18n/locales';

export const workpackAlertsIntl = {
    [LOCALES.ENGLISH]: {
        'workpackAlerts.emergency.title': 'Important',
        'workpackAlerts.emergency': 'This form is for emergency unplanned works only.',
        'workpackAlerts.error.title': 'Important',
        'workpackAlerts.error': 'Your submission has taken longer than expected to generate. Please check its progress on the Downloads page.',
        'workpackAlerts.button': 'Review PDF',
        'workpackAlerts.success.title': 'PDF Saved',
        'workpackAlerts.modal.button.save.text': 'Accept and continue'
    },
    [LOCALES.WELSH]: {
        'workpackAlerts.emergency.title': '[Important]',
        'workpackAlerts.emergency': '[This form is for emergency unplanned works only.]',
        'workpackAlerts.error.title': '[Important]',
        'workpackAlerts.error': '[Your submission has taken longer than expected to generate. Please check its progress on the Downloads page.]',
        'workpackAlerts.button': '[Review PDF]',
        'workpackAlerts.success.title': '[PDF Saved]',
        'workpackAlerts.modal.button.save.text': '[Accept and continue]'
    }
};
